import React, { Component } from 'react';
import './input.scss';

export class Input extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    handleChange(event) {
        this.props.onChange(event);
    }

    handleBlur(event) {
        if(this.props.onBlur) this.props.onBlur(event);
    }

    render() {
        const {error, value, name, placeholder, errorText} = this.props;
        const className = this.props.className || '';
        const type = this.props.type || 'text'
        const label = this.props.label || false;
        const inputPlaceholder = this.props.inputPlaceholder || "";
        const disabled = this.props.disabled || false;

        const renderErrorTextAlone = (label && error) && <div className="errorText">{errorText}</div>;

        return (
            <div className={`inputWrapper ${error ? 'inputError': ''} ${label ? 'label' : ''} ${className}`}>
                {renderErrorTextAlone}
                <input className="wraped" type={type} name={name} value={value} onBlur={this.handleBlur} onChange={this.handleChange} placeholder={inputPlaceholder} disabled={disabled}/>
                <div className="inputPlaceholder">
                    {label && placeholder}
                    {!label && (error ? errorText : placeholder)}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Form/Input.jsx